import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import EmailInput from "./EmailInput";
import Header from "./Header";
import classnames from "classnames";

export interface IEmailerProps {
    sendEmail: (data: any) => void;
    show: boolean;
    emailValues: any;
    header: string;
    label?: string;
    onChange: any;
    inputClassName?: string;
    headerClassName?: string;
    emailInputClassName?: string;
    emailSent: boolean;
    emailSentSubText?: string;
    className?: string;
}

export default (props: IEmailerProps) => {
    const { show, onChange, sendEmail, header, label = "", className, emailValues, emailSent, emailInputClassName = "", inputClassName = "", headerClassName = "", emailSentSubText = "" } = props;
    const [toggleButton, setToggle] = useState({ className: "btn-gainsboro border-gainsboro", disable: true });

    useEffect(() => {
        checkEmailValues();
    }, [emailValues, show]);

    function checkEmailValues() {
        let disable = false;
        Object.keys(emailValues).forEach(function (key) {
            if (!emailValues[key].isValid) {
                disable = true;
            }
        });

        toggleUpdateButton(disable);
    }

    function toggleUpdateButton(disable) {
        if (!disable) {
            setToggle({ className: "btn-primary", disable: false });
        } else {
            setToggle({ className: "btn-gainsboro border-gainsboro", disable: true });
        }
    }

    function sendEmailDetails() {
        toggleUpdateButton(true);
        sendEmail(emailValues);
    }

    function EmailSent({ subText }) {
        return (
            <div className="row p-4 pl-0 pb-5">
                <div className="col-12 pl-6">
                    <p>Email sent successfully. If the email is missing, please check your junk mail folder.</p>
                    <small>{subText}</small>
                </div >
            </div>
        );
    }

    const emailInputProps = {
        className: classnames("col-12", emailInputClassName),
        onChange,
        inputClassName: "bg-gray-200",
        show
    };
    const inputProps = {
        className: classnames("col-12", inputClassName),
        inputClassName: "bg-gray-200",
        onChange,
        show
    };
    const headerProps = {
        className: classnames("col-12", headerClassName),
        headerText: { header: header },
        label
    };

    if (!emailSent) {
        return (
            <div className={classnames("pb-5", className)} >
                <div className="row pl-0">
                    <Header {...headerProps} />
                </div>
                <div className="row">
                    <EmailInput {...inputProps} label="First name" id="FirstName" inputType="text" value={emailValues.FirstName} />
                    <EmailInput {...inputProps} label="Last name" id="LastName" inputType="text" value={emailValues.LastName} />
                </div>
                <div className="row">
                    <EmailInput {...emailInputProps} label="Email address" id="Email" inputType="email" value={emailValues.Email} />
                    <div className="col-12 col-lg-4 px-0">
                        <Button onClick={sendEmailDetails} className={classnames("w-100", "px-4", "py-2", toggleButton.className)} style={{ height: "54.75px" }} disabled={toggleButton.disable}> Send </Button>
                    </div>
                </div>
            </ div >
        );
    }
    return <EmailSent subText={emailSentSubText} />;
};